import { render } from "./DashboardDesktop.vue?vue&type=template&id=2beb10cf"
import script from "./DashboardDesktop.vue?vue&type=script&lang=js"
export * from "./DashboardDesktop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/application/dashboards/DashboardDesktop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2beb10cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2beb10cf', __exports__)) {
    api.reload('2beb10cf', __exports__)
  }
  
  module.hot.accept("./DashboardDesktop.vue?vue&type=template&id=2beb10cf", () => {
    api.rerender('2beb10cf', render)
  })

}


export default __exports__